import DapDSTOC from './toc.component'

export * from './toc.component'
export default DapDSTOC

DapDSTOC.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-toc': DapDSTOC
  }
}
